var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"location-panel-small-content"},[_c('app-sheet-location-small',{attrs:{"html-content":_vm.locationAdditionalDetails.shortRichText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }